import { render, staticRenderFns } from "./updateSupply.vue?vue&type=template&id=b90da206&scoped=true&"
import script from "./updateSupply.vue?vue&type=script&lang=js&"
export * from "./updateSupply.vue?vue&type=script&lang=js&"
import style0 from "./updateSupply.vue?vue&type=style&index=0&id=b90da206&prod&lang=css&"
import style1 from "./updateSupply.vue?vue&type=style&index=1&id=b90da206&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90da206",
  null
  
)

export default component.exports